import { render, staticRenderFns } from "./ShowColumns.vue?vue&type=template&id=10055528"
import script from "./ShowColumns.vue?vue&type=script&lang=js"
export * from "./ShowColumns.vue?vue&type=script&lang=js"
import style0 from "./ShowColumns.vue?vue&type=style&index=0&id=10055528&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports